<template>
  <div>
    <!-- COMPONENTE QUE GERA O LOADING EFECT -->
    <v-overlay :value="overlay || $store.state.loading_pdf">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- FIM COMPONENTE QUE GERA O LOADING EFECT -->

    <!-- ========= DIALOGO REGISTRAR BOLSEIRO ================ -->
    <div>
      <v-card>
        <v-card-title style="
            background-color: #006699;
            color: white;
            border: 1px solid #fff;
          ">
          <span class="text-h5">Registrar Bolseiro</span>
        </v-card-title>

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-text>
            <v-row>
              <v-col cols="4" sm="4" md="4">
                <v-combobox :rules="ruleRequired" v-model="ongBolsaSelected" :items="listaOngBolsas"
                  item-value="listaOngBolsas" item-text="nome" return-object label="Organização:"
                  @change="SelecionarOrganizacao()">
                  <template v-slot:item="{ item }">
                    <v-list-item-avatar v-if="item.icone" color="indigo" class="headline font-weight-light white--text">
                      <v-btn icon fab><v-icon style="color: white">add</v-icon></v-btn>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.nome"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-combobox>
              </v-col>

              <v-col cols="4" sm="4" md="4">
                <div class="tpaCombox">
                  <v-combobox v-model="tiposDescontosSelected" label="Tipo de desconto" item-value="id"
                    item-text="descricao" :items="tiposDescontos" return-object rounded>
                  </v-combobox>
                </div>
              </v-col>

              <v-col cols="4" sm="4" md="4">
                <v-text-field label="Valor do desconto" v-model="valorDoDesconto"></v-text-field>
              </v-col>

              <v-col cols="4" sm="4" md="4">
                <div class="tpaCombox">
                  <v-combobox v-model="tiposMultasSelected" label="Tipo de multa" item-value="id"
                    item-text="descricao" :items="tiposMultas" return-object rounded>
                  </v-combobox>
                </div>
              </v-col>

              <v-col cols="4" sm="4" md="4" v-if="tiposMultasSelected && tiposMultasSelected.id > 1">
                <v-text-field label="Desconto da multa" v-model="valorDaMulta"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black darken-1" text @click="resetarPagina()">
              fechar
            </v-btn>
            <v-btn color="green darken-1" text :disabled="!valid" @click="verificarBolseiroCadastrado()">
              salvar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </div>

    <!-- ========== NOVA ORGANIZAÇÃO ============== -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="cardNovaOrganizacao" persistent max-width="500px">
          <v-card>
            <v-overlay :value="overlayOrganizacao">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card-title>
              <span class="headline">Nova Organização</span>
            </v-card-title>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field v-model="nomeNovaOrganizacao"
                        label="Forneça o nome da nova organização"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="color: white" color="green darken-1" :disabled="!valid"
                @click="verificarOrganizacao()">Guardar</v-btn>
              <v-btn @click="resetarPagina()">Cancelar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!-- ========= FIM NOVA ORGANIZAÇÃO ================ -->
  </div>
</template>

<script>
import axios from "../../plugins/axios";
import utilitarios from "../../plugins/utilitarios";
const ls = require("local-storage");
export default {
  name: "RegistrarBolseiro",
  props: {
    estudante: null,
  },

  computed: {
    anoLectivoActual() {
      return ls.get('anolectivo');
    }
  },
  data: () => ({
    cardBolseiro: true,
    mostrarOpcoesBolsa: false,
    tipoDeBolsa: "",
    descricaoBolseiro: "",
    tipoBolseiroOng: [],
    cardNovaOrganizacao: false,
    overlayOrganizacao: false,
    nomeNovaOrganizacao: "",
    idNovaOrganizacao: null,
    bolseiroSelected: null,
    valorDesconto: "",
    tipoBolseiroSelected: "",
    listaOngBolsas: [],
    ongBolsaSelected: null,
    ruleRequired: [(value) => !!value || "campo obrigatorio"],
    overlay: false,
    tiposDescontos: [
      { id: 1, descricao: 'Percentagem' },
      { id: 0, descricao: 'Manual' }
    ],
    tiposDescontosSelected: null,
    tiposMultasSelected: null,
    tiposMultas: [
    { id: 1, descricao: 'Isento de todas multas'},
    { id: 2, descricao: 'Isento apenas de multas de mensalidades'},
    { id: 3, descricao: 'Isento apenas de multas que não sejam mensalidade'},
    ],
    valorDoDesconto: undefined,
    valorDaMulta: undefined,
  }),
  props: {
    estudante: null,
  },

  created() {
    this.carregarDadosBolseiros();
  },

  methods: {
    resetarPagina() {
      this.$emit("fecharComponente", false);
    },

    /**
     * Método responsavél por carregar os dados que serão necessário para registrar um bolseiro.
     * Trás a lista das organizações provedoras de bolsa disponivel
     * Trás a lista de todos os tipos de bolseiros salvo no Banco de dados
     * Caso houver um erro durante a requisição, será exibida uma notificação.
     */
    async carregarDadosBolseiros() {
      try {
        this.progresso = true;
        this.listaOngBolsas = await axios
          .get("/listarOrganizacoesBolsas")
          .then((res) => res.data);
        this.listaOngBolsas.unshift({
          nome: "Nova Organização",
          id: -1,
          icone: true,
        });
      } catch (error) {
        utilitarios.showAlertMessage(
          "error",
          "Ocorreu um error durante o carregamento da página!"
        );
      } finally {
        this.progresso = false;
      }
    },

    /**
     * Método responsavél tornar o cardNovaOrganizacao visivél.
     * Verifica se o usuário clicou na opcção "Nova Organização"
     * Reseta o valor da variavel ongBolsaSelected
     * Fecha o cardBolseiro
     */
    SelecionarOrganizacao() {
      this.mostrarOpcoesBolsa = false;
      if (this.ongBolsaSelected.tipo_bolseiro == 1) {
        this.tipoDeBolsa = 1;
        this.valorDesconto = "100%";
        this.descricaoBolseiro =
          "Os bolseiros dessa natureza são isentos de mensalidades e multas.";
      } else if (this.ongBolsaSelected.tipo_bolseiro == 2) {
        this.tipoDeBolsa = 2;
        this.valorDesconto = "0%";
        this.descricaoBolseiro =
          "Os bolseiros dessa natureza estão isentos do pagamento de multas decorrentes de atrasos no pagamento.";
      } else {
        this.tipoDeBolsa = 3;
        this.tipoBolseiroSelected = "Comparticipada";
        this.valorDesconto = "50%";
        this.descricaoBolseiro =
          "Os bolseiros desta natureza possuem direito a um desconto de 50% no pagamento da mensalidade.";
        this.mostrarOpcoesBolsa = true;
      }

      if (this.ongBolsaSelected.id === -1) {
        this.cardNovaOrganizacao = true;
        this.ongBolsaSelected = null;
        this.cardBolseiro = false;
      }
    },

    /**
     * Método responsavel por verificar se a organização já foi cadastrada.
     * Verica se o nome que está a ser inserido já existe no banco de dados
     * Valida se o campo está vázio
     * Se a organização já foi cadastrada antes, será exibido uma notificação
     * Se ainda não foi cadstrada, será chamado o método responsavél por cadastrar
     */
    async verificarOrganizacao() {
      if (this.$refs.form.validate() && this.nomeNovaOrganizacao) {
        let organizacaoExistente = await axios
          .get(
            `/verificarOrganizacaoExistente/${this.nomeNovaOrganizacao.trim()}`
          )
          .then((res) => res.data);
        if (organizacaoExistente.length) {
          utilitarios.showAlertMessage("error", "Organização já registrada!");
        } else {
          this.saveNovaOrganizacao();
        }
      }
    },

    /**
     * Método responsavél por cadastrar a nova organização inserida.
     * Se o cadastro ocorrer com sucesso, fecha o cardNovaOrganizacao e chamará a função this.carregarDadosBolseiros();
     * Caso ocorra um erro durante o cadastramento, será exibido uma notificação
     */
    async saveNovaOrganizacao() {
      if (this.$refs.form.validate()) {
        let params = {
          nomeOrgazacao: this.nomeNovaOrganizacao.trim(),
        };
        try {
          this.overlay = true;
          let result = await axios
            .post("/cadastrarNovaOrganizacao", params)
            .then((res) => res.data);
          if (result.affectedRows >= 1) {
            utilitarios.showAlertMessage(
              "success",
              "Organização adicionada com sucesso!"
            );
            this.fecharCardBolseiro();
          }
        } catch (error) {
          utilitarios.showAlertMessage(
            "error",
            "Ocorreu um erro ao adicionar a nova organização!"
          );
        } finally {
          this.overlay = false;
        }
      }
    },

    /**
     * Método responsavel por verificar se o bolseiro já foi cadastrado.
     * Verifica se o bilhete (nif) já existe na tabela bolseiros
     * Se o bolseiro já foi cadastrado antes, será exibido uma notificação
     * Se ainda não foi cadstrado, será chamado o método responsavél por cadastrar
     */
    async verificarBolseiroCadastrado() {
      if (this.$refs.form.validate()) {
        let bolseiroExistente = await axios
          .get(`/vericarBolseiroExistente/${this.estudante.numero_matricula}`)
          .then((res) => res.data);
        if (bolseiroExistente.length) {
          utilitarios.showAlertMessage(
            "info",
            "Bolseiro já registrado! Verifique a lista dos bolseiros revogados."
          );
        } else {
          this.salvarBolseiro();
        }
      }
    },

    /**
     * Método responsavél por cadastrar umnovo bolseiro.
     * Se o cadastro correr com sucesso, fecha o fecharCardBolseiro e chamará a função this.initialize();
     * Caso ocorra um erro durante o cadastramento, será exibido uma notificação
     */
    async salvarBolseiro() {
      if (this.$refs.form.validate()) {
        let params = {
          nome: this.estudante.nome,
          anoLectivo: this.anoLectivoActual,
          curso: this.estudante.descricao,
          nif: this.estudante.bi,
          matricula: this.estudante.numero_matricula,
          ongBolsa: this.ongBolsaSelected.nome,
          tipoDeDesconto: this.tiposDescontosSelected,
          valorDesconto: this.valorDoDesconto,
          tipoMulta: this.tiposMultasSelected,
          valorMulta: this.valorDaMulta
        };

        try {
          this.overlay = true;
          let result = await axios
            .post("/registrarBolseiro", params)
            .then((res) => res.data);
          if (result.affectedRows >= 0) {
            utilitarios.showAlertMessage(
              "success",
              "Bolseiro registrado com sucesso."
            );
            this.fecharCardBolseiro();
          }
        } catch (error) {
          utilitarios.showAlertMessage(
            "error",
            "Ocorreu um erro durante o registro do bolseiro!"
          );
        } finally {
          this.overlay = false;
        }
      }
    },

    /**
     * Método responsavél tornar o cardBolseiro invisivél.
     * Reseta o valor das variaveis tipoBolseiroSelected, valorDesconto, ongBolsaSelected
     */
    fecharCardBolseiro() {
      this.mostrarOpcoesBolsa = false;
      this.tipoDeBolsa = "";
      this.descricaoBolseiro = "";
      this.tipoBolseiroOng = [];
      this.cardNovaOrganizacao = false;
      this.nomeNovaOrganizacao = "";
      this.idNovaOrganizacao = null;
      this.bolseiroSelected = null;
      this.valorDesconto = "";
      this.tipoBolseiroSelected = "";
      this.listaOngBolsas = [];
      this.ongBolsaSelected = null;
      this.resetarPagina();
    },
    //======== FIM FUNÇÕES LIGADAS AS CADASTRO E FUNCIONAMENTO DOS BOLSEIROS ========== */
  },
};
</script>

<style scoped></style>
